import { env } from '../env';
/**
 * Here goes the global constants
 */
export const APPLICATION_ID = env.REACT_APP_ID_BOUTIQUE;
export const APP_NAME = 'FLOA Bank';
export const APP_DESCRIPTION = '';
export const DOMAIN_COOKIE = env.REACT_APP_DOMAIN_COOKIE;
export const CONTEXT_ROOT = env.REACT_APP_CONTEXT_ROOT;
export const API_ROOT = env.REACT_APP_API_ROOT || `${env.REACT_APP_CONTEXT_ROOT}/api/web`;
export const STATIC_ROOT = env.REACT_APP_STATIC_ROOT;
export const LARGE_LOGO_ROOT = env.REACT_APP_LARGE_LOGO_ROOT;
export const LOGO_ROOT = env.REACT_APP_LOGO_ROOT;
export const STATIC_CMS_ROOT = env.REACT_APP_STATIC_CMS_ROOT;
export const STATIC_RESOURCES_ROOT = env.REACT_APP_STATIC_RESOURCES_ROOT;
export const URL_PAGE_FACEBOOK = '';
export const URL_PAGE_TWITTER = '';
export const URL_PAGE_GOOGLEPLUS = '';

export const PAYMENT_THRESHOLD = 10;

export const REWRITE_PREFIX = 'FLOAB_';

export const IS_DEV = env.NODE_ENV === 'development';
export const IS_STAGING = env.REACT_APP_PROFILE === 'preproduction';
export const IS_PROD = env.NODE_ENV === 'production';

export const DATE_FORMAT_REDUXFORM = 'yyyy-mm-dd';

// action input reduxform change
export const REDUX_FORM_CHANGE = '@@redux-form/CHANGE';

export const TIMER_MS_INTERSTITIEL = 8000;
export const TIMER_MS_SSO = 5000;

export const FAQ_ID_WHY_CASHBACK_INVALIDATED =
    env.REACT_APP_FAQ_ID_WHY_CASHBACK_INVALIDATED || null;

export const CONTACT_REQUEST_REASON_ID_COMPLAINT =
    env.REACT_APP_CONTACT_REQUEST_REASON_ID_COMPLAINT || null;

export const GA_TRACKING_NUMBER_PLEBICOM = env.REACT_APP_GA_TRACKING_NUMBER_PLEBICOM;
export const GTM_CLIENT_ID = env.REACT_APP_GTM_CLIENT_ID;

export const HIDE_ALO = false;

export const ORCHESTRA_EMPLOYEE_SEGMENT_ID = 335;



// WEBPACK FOOTER //
// ./src/constants/index.js